import type { Ref } from 'vue'
import { ref, onUnmounted, watch } from 'vue'

interface UseDetectViewportVisibility {
  LoadMoreRef: Ref<HTMLElement | null>
}

export function useDetectViewportVisibility(callback: IntersectionObserverCallback): UseDetectViewportVisibility {
  const LoadMoreRef = ref<HTMLElement | null>(null)
  let intersectionObserver = new IntersectionObserver(callback)

  watch(
    LoadMoreRef,
    newRef => {
      if (newRef) {
        intersectionObserver.disconnect()
        intersectionObserver.observe(newRef)
      }
    },
    { immediate: true }
  )

  onUnmounted(() => {
    intersectionObserver?.disconnect()
  })

  return { LoadMoreRef }
}
